import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Response } from '../../../_shared/models';
import { AccountDateFilterRequest } from '../../../_shared/models/account-date-filter-request.model';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { OverviewTimeSeries } from '../models/overview-timeseries.model';

@Injectable({
  providedIn: 'root'
})
export class GlobalDriverOverviewService {

  constructor(private http: HttpClient) { }

  public getDriverTripTimeSeries(request: AccountDateFilterRequest, cancellation: Subject<void>): Promise<Response<OverviewTimeSeries[]>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driveroverview/global/driver-trips-time-series`, request).pipe(takeUntil(cancellation)));
  }

  public getDriverDistanceTimeSeries(request: AccountDateFilterRequest, cancellation: Subject<void>): Promise<Response<OverviewTimeSeries[]>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driveroverview/global/driver-distance-time-series`, request).pipe(takeUntil(cancellation)));
  }

  public getDriverPerformanceTimeSeries(request: AccountDateFilterRequest, cancellation: Subject<void>): Promise<Response<OverviewTimeSeries[]>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driveroverview/global/driver-performance-time-series`, request).pipe(takeUntil(cancellation)));
  }

  public getDriverOvertimeTimeSeries(request: AccountDateFilterRequest, cancellation: Subject<void>): Promise<Response<OverviewTimeSeries[]>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driveroverview/global/driver-overtime-cost-time-series`, request).pipe(takeUntil(cancellation)));
  }
}
